// extracted by mini-css-extract-plugin
export default {"container":"QuoteNettoBetList_container__5SsRb"};